import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, isRef as _isRef, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "kr-customs-tip-content" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { style: {"text-align":"center"} }
const _hoisted_5 = { class: "footer" }
const _hoisted_6 = { key: 0 }

import { ref, watch } from 'vue'
import { t } from '@/plugins/i18n'
import { customsShowTimeApi } from '@/apis/order'
import CommonDialog from '@/components/common/CommonDialog.vue'

export default /*#__PURE__*/_defineComponent({
  props: ['visible', 'type'],
  emits: ['update:visible', 'success'],
  setup(__props, { emit }) {

const props = __props


const isCheck = ref(false)
const cancel = () => {
  emit('update:visible', false)
}
const submit = () => {
  customsShowTimeApi({
    expireDate: isCheck.value ? 0 : 3,
    type: props.type
  }).then((res: any) => {
    if (res.success) {
      emit('update:visible', false)
      emit('success')
    }
  })
}
const num = ref(10)
let timer: any = null
watch(() => props.visible, (newValue) => {
  if (newValue) {
    timer = setInterval(() => {
      num.value--
      if (num.value === 0) {
        clearInterval(timer)
      }
    }, 1000)
  } else {
    num.value = 10
    clearInterval(timer)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(CommonDialog, {
    onCancel: cancel,
    className: "kr-customs-tip",
    visible: __props.visible,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
    width: 520,
    "append-to-body": "",
    noHeader: true,
    "modal-class": "kr-customs-tip-modal",
    "close-on-click-modal": false,
    hiddenClose: num.value > 0
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, _toDisplayString(_unref(t)('根据韩国海关的要求选择附加项：')), 1),
        _createElementVNode("div", null, _toDisplayString(_unref(t)('最终选择用企业通关来国际发货时-')), 1),
        _createElementVNode("div", null, _toDisplayString(_unref(t)('如果是纺织品（例：衣服/被子等）')), 1),
        _createElementVNode("div", {
          innerHTML: _unref(t)('在下单时一定需要选择水洗标制作和水洗标缝制服务！')
        }, null, 8, _hoisted_2),
        _createElementVNode("div", null, _toDisplayString(_unref(t)('如果是杂货（例：发卡/文具等）')), 1),
        _createElementVNode("div", {
          innerHTML: _unref(t)('一定在发货时选择贴原产地标服务！')
        }, null, 8, _hoisted_3),
        _createElementVNode("div", null, _toDisplayString(_unref(t)('如果不能确认请联系页面右方的客服中心服务！')), 1),
        _createElementVNode("p", _hoisted_4, [
          _createVNode(_component_el_checkbox, {
            modelValue: isCheck.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isCheck).value = $event)),
            label: _unref(t)('不再提示'),
            size: "large"
          }, null, 8, ["modelValue", "label"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit,
          class: "btn",
          disabled: num.value > 0
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('我知道了2')), 1),
            (num.value > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "(" + _toDisplayString(num.value) + ")", 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "hiddenClose"]))
}
}

})